import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft, ShieldAlert, Smartphone, LayoutGrid, AppWindow, Shield } from 'lucide-react';
import { MainLayout } from '../components/MainLayout';
import { useAuth } from '../contexts/AuthContext';

export default function AccessDenied() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <MainLayout>
      <div className="ios-app-lock-container animate-fade-in">
        <div className="ios-app-lock-card animate-scale-up">
          {/* iOS Status Header */}
          <div className="v-lock-header" style={{ marginBottom: '14px' }}>
            <div className="v-lock-badge locked">
              <ShieldAlert size={13} className="v-lock-icon-locked" />
              <span>Access Restricted</span>
            </div>
            <div className="v-lock-os-badge">
              <Smartphone size={11} />
              <span>iOS Security</span>
            </div>
          </div>

          {/* iOS Warning Shield Bubble */}
          <div className="ios-denied-icon-bubble animate-pulse">
            <ShieldAlert size={34} color="#f43f5e" strokeWidth={2.2} />
          </div>

          <h1 className="ios-app-lock-title" style={{ fontSize: '1.2rem', marginTop: '10px' }}>
            Access Restricted
          </h1>
          <p className="ios-app-lock-subtitle" style={{ fontSize: '0.78rem', color: '#94a3b8', lineHeight: '1.45', margin: '6px 0 16px' }}>
            This application contains sensitive zero-knowledge resources and requires authorized administrator privileges or assigned permissions to access.
          </p>

          {/* Apple Inset Details Box */}
          <div className="ios-inset-details-box">
            <div className="ios-inset-row">
              <span className="ios-inset-key">Account</span>
              <span className="ios-inset-val">{user?.email || 'Active User'}</span>
            </div>
            <div className="ios-inset-row">
              <span className="ios-inset-key">Permission Role</span>
              <span className="ios-inset-val">{user?.role || 'Standard'}</span>
            </div>
            <div className="ios-inset-row">
              <span className="ios-inset-key">Status</span>
              <span className="ios-inset-val" style={{ color: '#34d399' }}>Session Active</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="ios-denied-actions-col">
            <Link to="/dashboard" className="v-btn-primary-scan" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <LayoutGrid size={16} />
              <span>Return to Dashboard</span>
            </Link>

            <Link to="/apps" className="ios-btn-secondary" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <AppWindow size={15} />
              <span>Browse Applications</span>
            </Link>

            <button
              type="button"
              className="ios-lock-cancel-btn"
              onClick={() => navigate(-1)}
              style={{ marginTop: '4px' }}
            >
              <ArrowLeft size={14} />
              <span>Go Back</span>
            </button>
          </div>

          {/* Session Footnote */}
          <div className="ios-lock-session-pill" style={{ marginTop: '12px' }}>
            <span className="ios-lock-dot-live" />
            <span>Authenticated • Zero-Knowledge Policy</span>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

